// LeaderboardPage.jsx
import React from "react";
import "./LeaderboardPage.css";

export default function LeaderboardPage() {
  const row = {
    id: 1,
    school: "",
    submissionCount: "",
    individual: { first: "", second: "", third: "" },
    team: { first: "", second: "", third: "" },
    totalScore: "",
  };
  const rows = row.school && row.school.trim() ? [row] : [];
  const hasRows = rows.length > 0;

  return (
    <div className="leaderboard-container">
      <h1 className="leaderboard-title">Leader Board</h1>

      <div className="leaderboard-content">
        <div className="leaderboard-info">
          <p>
            BTUI 2026 introduces the Overall Championship Award, recognizing the
            school that demonstrates outstanding performance and participation
            across all competitions.
          </p>
          <h3>Scoring System</h3>
          <ul>
            <li>Each valid submission for any competition will earn the respective school 50 points.</li>
            <li>For Individual Competitions:
              <ul>
                <li>1st Place: 300 points</li>
                <li>2nd Place: 200 points</li>
                <li>3rd Place: 100 points</li>
              </ul>
            </li>
            <li>For Team Competitions:
              <ul>
                <li>1st Place: 600 points</li>
                <li>2nd Place: 500 points</li>
                <li>3rd Place: 400 points</li>
              </ul>
            </li>
          </ul>
          <p>
            The total score of each school will be calculated based on both
            submissions and placement points. The school achieving the highest
            cumulative score will be crowned the Overall Champion of BTUI 2026.
          </p>
        </div>

        <div className="table-wrapper">
          <table className="leaderboard-table">
            <thead>
              <tr>
                <th rowSpan="2">School Name</th>
                <th rowSpan="2">Submission Count</th>
                <th colSpan="3">Individual Competition</th>
                <th colSpan="3">Team Competition</th>
                <th rowSpan="2">Total Score</th>
              </tr>
              <tr>
                <th>1st</th>
                <th>2nd</th>
                <th>3rd</th>
                <th>1st</th>
                <th>2nd</th>
                <th>3rd</th>
              </tr>
            </thead>
            <tbody>
              {hasRows ? (
                rows.map((entry) => (
                  <tr key={entry.id}>
                    <td>{entry.school}</td>
                    <td>{entry.submissionCount}</td>
                    <td>{entry.individual.first}</td>
                    <td>{entry.individual.second}</td>
                    <td>{entry.individual.third}</td>
                    <td>{entry.team.first}</td>
                    <td>{entry.team.second}</td>
                    <td>{entry.team.third}</td>
                    <td>{entry.totalScore}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="leaderboard-empty" colSpan="9">
                    No schools yet. Results will appear here once scoring is published.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
